<template>
  <div class="settings--content">
    <settings-section
      title="Forçar atualização do token"
      sub-title="Atualiza manualmente o token da integração do WhatsApp Cloud."
    >
      <div class="whatsapp-settings--content">
        <woot-button
          variant="smooth"
          color-scheme="secondary"
          :is-loading="isRefreshingWhatsappToken"
          :disabled="isForceTokenRefreshDisabled"
          @click="$emit('force-token-refresh')"
        >
          Forçar atualização do token
        </woot-button>
        <p v-if="isForceTokenRefreshDisabled" class="help-text">
          A atualização manual do token fica bloqueada quando a última
          atualização ultrapassa 60 dias.
        </p>
      </div>
    </settings-section>

    <settings-section
      :title="$t('INBOX_MGMT.REAUTH')"
      sub-title="Realiza a reautorização da conta no provedor do WhatsApp."
    >
      <div class="whatsapp-settings--content">
        <woot-button
          variant="smooth"
          color-scheme="secondary"
          :is-loading="isRequestingWhatsappAuthorization"
          @click="$emit('request-whatsapp-reauthorization')"
        >
          {{ $t('INBOX_MGMT.REAUTH') }}
        </woot-button>
      </div>
    </settings-section>
  </div>
</template>

<script>
import SettingsSection from '../../../../../components/SettingsSection';

const SIXTY_DAYS_IN_MS = 60 * 24 * 60 * 60 * 1000;

export default {
  components: {
    SettingsSection,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
    isRefreshingWhatsappToken: {
      type: Boolean,
      default: false,
    },
    isRequestingWhatsappAuthorization: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isForceTokenRefreshDisabled() {
      const lastTokenUpdate = this.inbox?.last_token_update;
      if (!lastTokenUpdate) {
        return false;
      }

      const parsedDate = new Date(lastTokenUpdate);
      if (Number.isNaN(parsedDate.getTime())) {
        return false;
      }

      return Date.now() - parsedDate.getTime() > SIXTY_DAYS_IN_MS;
    },
  },
};
</script>

<style scoped lang="scss">
.settings--content {
    display: block !important;
}
.whatsapp-settings--content {
  display: flex;
  flex-direction: column;
  gap: var(--space-small);
  > button {
    max-width: 300px;
  }
}

.help-text {
  margin-bottom: 0;
  font-style: normal;
  color: var(--b-500);
}
</style>